import React, {
  forwardRef,
  useImperativeHandle,
  useLayoutEffect,
  useState,
} from "react";
import SelectionRectOverlay from "./SelectionRectOverlay";

// Pointer frames update this small subtree, rather than the editor's parent state.
const InteractionRectOverlay = forwardRef(function InteractionRectOverlay(
  {
    isDrawing,
    isSelecting,
    rect,
    selectionRect,
    scaleFactor,
    activeEditorTool,
  },
  ref,
) {
  const [drawingRect, setDrawingRect] = useState(rect);
  const [selectingRect, setSelectingRect] = useState(selectionRect);
  useLayoutEffect(() => {
    setDrawingRect(rect);
  }, [rect, isDrawing]);
  useLayoutEffect(() => {
    setSelectingRect(selectionRect);
  }, [selectionRect, isSelecting]);
  useImperativeHandle(ref, () => ({ setDrawingRect, setSelectingRect }), []);
  const displayRect = (value) => ({
    left: value.x * scaleFactor,
    top: value.y * scaleFactor,
    width: value.width * scaleFactor,
    height: value.height * scaleFactor,
  });
  return (
    <>
      {isDrawing && drawingRect && (
        <SelectionRectOverlay
          rect={displayRect(drawingRect)}
          activeEditorTool={activeEditorTool}
        />
      )}
      {isSelecting && selectingRect && (
        <SelectionRectOverlay
          rect={displayRect(selectingRect)}
          activeEditorTool={activeEditorTool}
        />
      )}
    </>
  );
});

export default InteractionRectOverlay;
